export const assertNever = (v: never): never => {
  throw new Error(`Unhandled discriminated union member: ${v as unknown as string}`);
};

// Make all the code pause for a specified amount of time (create lag)
export const wait = (ms: number) => {
  const start = new Date().getTime();
  let end = start;
  while (end < start + ms) {
    end = new Date().getTime();
  }
  return;
};

/* This method takes a cb function that you want to call with an implicit flag. That means
that if it keeps erroring out, you want to wait for it to not error out. 
Optionally, you can specify 
- triesLeft: the # of attempts 
- interval: time between each attempt
*/
export const tryUntil = (callback: () => void, triesLeft = 100, interval = 200) => {
  if (triesLeft < 0) return;
  try {
    callback();
  } catch (e) {
    setTimeout(() => tryUntil(callback, triesLeft - 1, interval), interval);
  }
};

export const renderBlank = () => null;

export const noop = () => void 0;

/**
 * Ensures the given URL has the specified query parameter. If the URL already has
 * the parameter, it is returned unchanged. Otherwise appends ?paramName= or &paramName=
 * with the encoded param value.
 * @param paramName Query parameter name (e.g. "ReturnUrl"). Defaults to "ReturnUrl".
 */
export function ensureUrlHasQueryParam(baseUrl: string, paramValue: string, paramName = 'ReturnUrl'): string {
  const escaped = paramName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const hasParam = new RegExp(`[?&]${escaped}=`, 'i').test(baseUrl);
  if (hasParam) {
    return baseUrl;
  }
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${paramName}=${encodeURIComponent(paramValue)}`;
}
